import '../application';

$(document).ready(() => {
  // Back-to-top link click event.
  $('#scroll-top-link-button').click(() => {
    $([document.documentElement, document.body]).animate({
      scrollTop: $('.section-hero').offset().top
    }, 200);

    return false;
  });

  // Window scroll event
  window.onscroll = () => {
    toggleTopLink();
  };

  toggleTopLink();
});

/**
 * Show or hide back-to-top link.
 */
function toggleTopLink () {
  if (
    (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) &&
    Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) > 599 // 599 Matches the show/hide CSS min-width media query breakpoint set at 600px.
  ) {
    $('.section-list .scroll-top-link').show();
  } else {
    $('.section-list .scroll-top-link').hide();
  }
}

// Assign event handlers for private event tooltip buttons.
$('.private-event-tooltip-button').each(function () {
  // Button - mouse enter event.
  $(this).unbind('mouseenter').bind('mouseenter', function () {
    const $this = $(this);
    const $popup = $('.private-event-tooltip-popup');
    if ($popup.length) {
      const buttonOffset = $this.offset();
      const buttonHeight = $this.height();
      const popupWidth = $popup.width();
      const popupHeight = $popup.height();
      const popupPadding = parseInt($popup.css('padding'));
      $popup.css({
        display: 'block',
        top: buttonOffset.top - popupHeight - (popupPadding * 2) - buttonHeight,
        left: buttonOffset.left - parseInt(popupWidth / 2)
      });
    }
  });
  // Button - mouse leave event.
  $(this).unbind('mouseleave').bind('mouseleave', function () {
    $('.private-event-tooltip-popup').css('display', 'none');
  });
});
